import React, {useCallback, useEffect, useState} from 'react';
import {Formik} from "formik";
import FieldCustom from "../Field/FieldCustom";
import loginForm from "../Login/LoginForm";
import AxiosConfig from "../../services/AxiosConfig";
import styles from './../Search/Search.module.css';
import {registerUserToSeanceByCoachAPI} from "../../services/SeanceService";
import {useModal} from "../../contexts/ModalContext";
import {searchUsers} from "../../services/SearchService";

const AddPeopleForm = ({ id, onSubmit= null, entrepriseId = null }) => {
    const [suggestions, setSuggestions] = useState([]);
    const { showModal } = useModal();

    const handleSuccess = useCallback((message = "Succès") => {
        showModal('success', { children: message, timeout: 3000 });
    }, [showModal]);

    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', { children: message, timeout: 3000 });
    }, [showModal]);

    const fetchSuggestions = async (value) => {
        if (!value) {
            setSuggestions([]);
            return;
        }
        const response = await searchUsers(value, entrepriseId);
        setSuggestions(response);
    };

    const handleInputChange = async (e, setFieldValue) => {
        const value = e.target.value;
        setFieldValue('email', value);
        await fetchSuggestions(value);
    };

    const handleSuggestionClick = (suggestion, setFieldValue) => {
        setFieldValue('email', suggestion.email);
        setSuggestions([]);
    };

    return (
        <div className={"blocContainer"}>
            <h3>Personnes supplémentaires</h3>
            <span>Ajoutez les emails des personnes non-inscrit(e)s</span>

            {/* TODO : Faire un composant SearchField */}
            <Formik
                initialValues={{ email: '' }}
                onSubmit={async (values, {setSubmitting}) => {
                    const response = await registerUserToSeanceByCoachAPI(id, values)
                    if (response.success) {
                        handleSuccess(response.msg);
                    } else {
                        handleError(response.msg);
                    }

                    setSubmitting(false);

                    if (onSubmit) {
                        onSubmit();
                    }
                }}
            >
                {({ handleSubmit, isSubmitting, setFieldValue }) => (
                    <form autoComplete="off" onSubmit={handleSubmit} className={`spaceBottom ${styles.form}`} style={{ textAlign: "center" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", position: "relative" }}>
                            <FieldCustom
                                type={"text"}
                                placeholder={"Recherchez par email..."}
                                id={"email"}
                                name={"email"}
                                label={""}
                                onChange={(e) => handleInputChange(e, setFieldValue)}
                            />

                            <div className={styles.listeDeroulanteContainer}>
                                {suggestions.length > 0 ? (
                                    <ul className="suggestions">
                                        {suggestions.map(suggestion => (
                                            <li key={suggestion.id} onClick={() => handleSuggestionClick(suggestion, setFieldValue)}>
                                                {suggestion.prenom} {suggestion.nom} - {suggestion.email}
                                            </li>
                                        ))}
                                    </ul>
                                ) : null }
                            </div>
                        </div>

                        <button type="submit" className="btn btn_success" disabled={isSubmitting}>Ajouter</button>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default AddPeopleForm;
